import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onMounted } from "vue";
import { UsuarioEloTablaClasificacion } from "@/interfaces/Elo";
import { FaccionDTO } from "@/interfaces/Faccion";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'TablaClasificacionEloEquipos',
  props: {
    items: {},
    facciones: {}
  },
  setup(__props: any) {

const props = __props;

const equipos = ref<Array<any>>([]);
const search = ref<string>("");

const headers = [
  { title: "#", key: "clasificacion" },
  { title: "Equipo", key: "equipo" },
  { title: "ELO", key: "elo" },
];

const groupByEquipos = () => {
  if (!props.items || !props.items.length) return;

  const jugadoresPorEquipo = Object.groupBy(
    props.items,
    ({ idFaccion }) => idFaccion
  );

  if (!Object.keys(jugadoresPorEquipo).length) return;

  equipos.value = [];

  for (const [, value] of Object.entries(jugadoresPorEquipo)) {
    if (value) {
      const nombre = props.facciones.find(
        faccion => faccion.idFaccion === value[0].idFaccion
      )?.nombreFaccion;

      if (!nombre) continue;

      const elo = (value.reduce((a, b) => a + b.elo, 0) / value.length).toFixed(
        2
      );
      const ganadas = value.reduce((a, b) => a + b.ganadas, 0);
      const empatadas = value.reduce((a, b) => a + b.empatadas, 0);
      const perdidas = value.reduce((a, b) => a + b.perdidas, 0);
      const partidas = ganadas + empatadas + perdidas;

      equipos.value.push({
        equipo: nombre,
        elo,
        ganadas,
        empatadas,
        perdidas,
        partidas,
      });
    }
  }

  equipos.value.sort((a, b) => parseFloat(b.elo) - parseFloat(a.elo));
  equipos.value = equipos.value.map((item, index) => ({
    ...item,
    clasificacion: index + 1,
  }));
};

onMounted(() => {
  groupByEquipos();
});

watch(
  () => props.items,
  newItems => {
    if (newItems && newItems.length) {
      groupByEquipos();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createTextVNode("Equipos "),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_text_field, {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            density: "compact",
            label: "Buscar",
            "prepend-inner-icon": "mdi-magnify",
            variant: "solo-filled",
            flat: "",
            "hide-details": "",
            "single-line": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_data_table, {
        search: search.value,
        "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
        items: equipos.value,
        headers: headers,
        loading: Boolean(!equipos.value.length),
        class: "custom-table",
        "item-key": "equipo"
      }, {
        item: _withCtx(({ item }) => [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(item.clasificacion), 1),
            _createElementVNode("td", null, _toDisplayString(item.equipo), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_v_chip, {
                color: "blue",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.elo), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ]),
        _: 1
      }, 8, ["search", "items", "loading"])
    ]),
    _: 1
  }))
}
}

})